

























import { NotificationType } from "@/types/notification";
import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class BaseStats extends Vue {
  // Takes an array of up to three stats
  @Prop({ required: true })
  stats!: {
    value: number | string | null | false;
    label: string;
    labelNarrow?: boolean;
    icon?: string;
    iconToolTip?: string;
    iconBlock?: boolean;
    iconIssueType?: NotificationType;
    small?: boolean;
  }[];
}
